import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow flex items-center justify-center bg-background px-4">
        <div className="text-center max-w-2xl mx-auto">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              {language === 'en' ? 'Page Not Found' : 'Página No Encontrada'}
            </h2>
            <p className="text-xl text-muted-foreground mb-8">
              {language === 'en' 
                ? 'Sorry, the page you are looking for does not exist or has been moved.'
                : 'Lo sentimos, la página que busca no existe o ha sido movida.'}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to={`/${language}`}>
              <Button variant="hero" size="lg" className="w-full sm:w-auto">
                <Home className="mr-2 h-5 w-5" />
                {language === 'en' ? 'Go to Homepage' : 'Ir al Inicio'}
              </Button>
            </Link>
            
            <Button 
              variant="outline" 
              size="lg" 
              onClick={() => window.history.back()}
              className="w-full sm:w-auto"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              {language === 'en' ? 'Go Back' : 'Regresar'}
            </Button>
          </div>

          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-muted-foreground mb-4">
              {language === 'en' ? 'Need help? Contact us:' : '¿Necesita ayuda? Contáctenos:'}
            </p>
            <a 
              href="tel:9363200763" 
              className="text-primary hover:text-primary/80 font-semibold text-lg"
            >
              (936) 320-0763
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
